import { useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import { get } from "@/lib/api";
import { cn } from "@/lib/utils";
import { fmtDate } from "@/lib/format";

/** Data-grounded driftsbrief (LLM phrasing with deterministic fallback, cached per hour on the backend). */
export const useBrief = (enabled = true) =>
  useQuery({ queryKey: ["dashboard-brief"], queryFn: () => get("/dashboard/brief"), staleTime: 15 * 60_000, refetchInterval: 30 * 60_000, enabled, retry: 1 });

/** One calm line under the greeting: «13 aktive prosjekt · Mongstad leveres i dag · 2 kritiske avvik · kapasitet 66 % i U46». */
export const AiBriefLine = ({ brief, className }) => {
  if (brief.isLoading) {
    return (
      <div className={cn("relative pl-7", className)} data-testid="dashboard-brief-loading" aria-busy="true">
        <Sparkles className="absolute left-0 top-[5px] h-4 w-4 text-primary/70" strokeWidth={1.75} aria-hidden />
        <span className="block h-4 w-[min(560px,80vw)] animate-pulse rounded-full bg-muted" />
        <span className="mt-2.5 block h-4 w-[min(380px,60vw)] animate-pulse rounded-full bg-muted" />
      </div>
    );
  }
  const b = brief.data;
  if (!b?.brief) return null;
  const sentences = String(b.brief).split(/(?<=[.!?])\s+/).map((s) => s.trim()).filter(Boolean);
  return (
    <div className={cn("relative pl-7", className)} data-testid="dashboard-brief">
      <Sparkles className="absolute left-0 top-[5px] h-4 w-4 text-primary" strokeWidth={1.75} aria-hidden />
      <p className="text-[16px] leading-7 text-foreground/90 sm:text-[17px]" data-testid="dashboard-brief-text">
        {sentences.map((s, i) => (
          <span key={i} className={cn(i === 0 && "font-medium text-foreground")}>
            {s}{" "}
          </span>
        ))}
      </p>
      <p className="mt-1 text-[11.5px] leading-4 text-muted-foreground" data-testid="dashboard-brief-meta">
        {b.source === "llm" ? "AI-driftsbrief basert på dagens tall" : "Driftsbrief basert på dagens tall"}
        {b.generated_at ? ` · ${fmtDate(b.generated_at, "HH:mm")}` : ""}
      </p>
    </div>
  );
};
